import { InHouseTasks } from "./InHouseTasks";
import { AvailabilityInfo } from "./AvailabilityInfo";
// import {InHouseTaskTaskData} from '@/interfaces/InHouseTasks/InhouseTaskTaskData'


export interface VerifyPhoneNumberInHouseTask extends InHouseTasks {
    status: 'unverified' | 'verified' | 'pending_sms';
}

export function createVerifyPhoneNumberInHouseTask(task: any): VerifyPhoneNumberInHouseTask {
    const availabilityInfo: AvailabilityInfo = {
        available_at: task.availability_info.available_at,
        available_in: task.availability_info.available_in,
        can_complete: task.availability_info.can_complete,
        is_available: task.availability_info.is_available,
    };

    return {
        id: task.id,
        name: task.name,
        description: task.description,
        coins_amount: task.coins_amount,
        availability: task.availability,
        availability_info: availabilityInfo,
        phone_number: '',
        phone_country_code: '',
        phone_iso_code: '',
        status: 'unverified',
    };
}